// ======================================================================
// File Name       : enterprise
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const ENTERPRISE_UPDATE = 'ENTERPRISE_UPDATE';
export const ENTERPRISE_RECEIVE_GET_STRUCTURE = 'ENTERPRISE_RECEIVE_GET_STRUCTURE';
export const ENTERPRISE_INIT_EDIT = 'ENTERPRISE_INIT_EDIT';
export const ENTERPRISE_INIT_REGISTER = 'ENTERPRISE_INIT_REGISTER';
export const ENTERPRISE_USAGE_INFO_UPDATE = 'ENTERPRISE_USAGE_INFO_UPDATE';
// sprint_20230403 #14 START
export const ENTERPRISE_PRECANCEL = 'ENTERPRISE_PRECANCEL';
// sprint_20230403 #14 END
export const ENTERPRISE_SAVE_REASON = 'ENTERPRISE_SAVE_REASON';
